export default __webpack_public_path__ + "static/media/tmdb-logo.da3f379f.svg";